import "react";
import { Button, Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import { MdPassword } from "react-icons/md";
//#region src/modules/AuthWrapper2/components/Login/views/ResetRequested.tsx
function ResetRequested({ onBack }) {
	return /* @__PURE__ */ jsxs("div", {
		className: "flex flex-col items-center",
		children: [
			/* @__PURE__ */ jsx(Icon, {
				Icon: MdPassword,
				size: "xxl",
				color: "positive"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "mt-base text-center text-lg font-medium",
				children: "Password Request Sent"
			}),
			/* @__PURE__ */ jsx("div", {
				className: "text-color-subtle mt-xs text-center text-sm",
				children: "If an account exists for that email, reset instructions have been sent. Check your inbox for instructions on how to proceed."
			}),
			!!onBack && /* @__PURE__ */ jsx(Button, {
				className: "mt-xl",
				subtle: true,
				onClick: onBack,
				children: "Back to Login"
			})
		]
	});
}
//#endregion
export { ResetRequested };

//# sourceMappingURL=ResetRequested.js.map